import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import moment from 'moment';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

export default class HistoryCellRenderer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleShow = () => {
        if (this.props.data.histories.length) {
            this.setState({ show: true });
        }
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div>
                <button onClick={this.handleShow} className="edit-order-btn">
                    <span>{this.props.data.histories.length} records</span>
                </button>
                <ModalStyled
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.data.histories.length} records</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            {this.props.data.histories.length > 0 &&
                                this.props.data.histories.map((history, index) => {
                                    return (
                                        <div className="row form-row history-row" key={index}>
                                            <div className="col-12 col-md-3 history-date">
                                                {moment(history.date).format('MM/DD/YYYY')}
                                            </div>
                                            <div className="col-12 col-md-9 history-description">
                                                {history.description}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </ModalStyled>
            </div>
        );
    }
}
